import Link from 'ageas-react-component-link'
import moment from 'moment'

import { Address, MatchedEntity } from '../../@types/GetEntitiesDetails'
import { MatchedEntity as MatchedIndividualEntity } from '../../@types/PolicyHolderDetails'
import { Cell, Header, Row, Table } from '../../Components/TablePacks/styles'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useEntityDetailsForSummaryDocumentStore } from '../../Stores/useEntityDetailsForSummaryDocumentStore'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { t } from '../../i18n'
import { SelectedAddress } from './SelectedAddress'
import { SelectedPolicyholderAddress } from './SelectedPolicyholderAddress'

type EntityTableSelectionProps = {
  data: Partial<MatchedIndividualEntity[] | MatchedEntity[]> | undefined
  type?: 'entity' | 'policyHolder' | 'entityForSummaryDocument'
  closeAction?: () => void
}

export const EntityTableSelection = ({
  data,
  type,
  closeAction = () => {},
}: EntityTableSelectionProps) => {
  const { setEntitySelected, setEntitySelectedAddress, setOwnerFiscalNumber } =
    useSimulatorStore()
  const {
    policyholderDetailsSelected,
    setPolicyholderDetailsSelected,
    setPolicyholderAddressSelected,
  } = usePolicyholderDetailsStore()
  const { setEntityDetailsForSummaryDocumentSelected } =
    useEntityDetailsForSummaryDocumentStore()
  const { isGenerateProposalDocuments } = useGenerateProposalDocumentsStore()

  const getEntityPhone = (item: MatchedEntity) => item.entityPhone

  return (
    <>
      <Table>
        <thead>
          <Row>
            <Header>{t('table.vatNumber')}</Header>
            <Header>{t('table.name')}</Header>
            <Header>{t('table.address')}</Header>
            <Header>{t('table.birthday')}</Header>
            <Header>{t('table.phone')}</Header>
          </Row>
        </thead>
        <tbody>
          {data?.map((item) => (
            <Row key={item?.vatNumber}>
              <Cell>
                <div className="excerpt">
                  <div className="button-nif">
                    <Link
                      readOnly={isGenerateProposalDocuments}
                      entity
                      userCardDetailLink
                      noPaddingTopBottom
                      label={item?.vatNumber}
                      onValueChanged={() => {
                        if (type === 'entity') {
                          setEntitySelected(item!)
                          setOwnerFiscalNumber(item?.vatNumber || '')
                          if (item?.addresses?.length === 1) {
                            setEntitySelectedAddress(
                              item?.addresses?.[0] as Address,
                            )
                          }
                        } else if (type === 'entityForSummaryDocument') {
                          setEntityDetailsForSummaryDocumentSelected(
                            item as never,
                          )
                          if (item?.addresses?.length === 1) {
                            setEntitySelectedAddress(
                              item?.addresses?.[0] as Address,
                            )
                          }
                        } else {
                          setPolicyholderDetailsSelected(item! as any)
                          if (item?.addresses?.length === 1) {
                            setPolicyholderAddressSelected(item?.addresses?.[0])
                          }
                        }

                        closeAction()
                      }}
                    />
                  </div>
                </div>
              </Cell>
              <Cell>
                <div className="excerpt">{item?.name}</div>
              </Cell>
              <Cell>
                {type === 'policyHolder' ? (
                  <SelectedPolicyholderAddress
                    addresses={item?.addresses as never}
                  />
                ) : (
                  <SelectedAddress addresses={item?.addresses as never} />
                )}
              </Cell>
              <Cell>
                <div className="excerpt">
                  {item?.birthdate && moment(item.birthdate).isValid() 
                    ? moment(item.birthdate).format('DD-MM-YYYY') 
                    : '-'}
                </div>
              </Cell>
              <Cell>
                {/* <div className="excerpt">{item?.entityPhone}</div> */}
                <div className="excerpt">
                  {(type === 'entity' || type === 'entityForSummaryDocument') &&
                    getEntityPhone(item!)}
                  {type !== 'entity' &&
                    type !== 'entityForSummaryDocument' &&
                    policyholderDetailsSelected?.phoneContactsList?.[0]
                      ?.contactNumber}
                </div>
              </Cell>
            </Row>
          ))}
        </tbody>
      </Table>
    </>
  )
}
